<div class="copy-text-value">
  <div class="copy-text-value__value" (click)="copyValue()">
    <span>{{ value }}</span>
    <img
      *ngIf="showIcon"
      alt="Copiar"
      src="/images/icons/atm-cta-copy-human.svg"
    />
    <div class="copy-text-value__message">
      {{ message }}
    </div>
  </div>
</div>
